import React from "react";
import { usePermissions } from "@/context/PermissionsContext";
import { Lock } from "lucide-react";

/**
 * Route-level gate for report pages (Phase 3).
 * Admins get can()===true for every key, so they always pass.
 * Users whose role default / per-user override lacks `perm` see an
 * Access Denied card instead of the report. No redirect, no page logic touched.
 */
export default function PermGate({ perm, children }) {
  const { can, loading } = usePermissions();
  if (loading) return null;
  if (perm && !can(perm)) {
    return (
      <div className="max-w-6xl mx-auto" data-testid="report-access-denied">
        <div className="ck-card p-10 text-center mt-6">
          <Lock size={28} className="mx-auto text-[#B87B41] mb-3" />
          <div className="font-display font-bold text-lg">Access denied</div>
          <div className="text-sm text-[#8A8782] mt-1">
            This report isn&apos;t enabled for your account. Ask an admin to turn it on under Users &amp; Permissions.
          </div>
        </div>
      </div>
    );
  }
  return children;
}
